import React from 'react';
import Icon from '../Icon/Icon';
import { number } from 'prop-types';

const getIconType = status => {
  switch (status) {
    case 0:
      return 'wait';
    case 1:
      return 'check-rounded';
    case 2:
      return 'cross-rounded';
    case 3:
      return 'wait';
    case 4:
      return 'cross-rounded';
    default:
      return 'wait';
  }
};

const PaymentStatusIcon = ({ status }) => (
  <Icon className='payment-status-icon' type={getIconType(status)} />
);

PaymentStatusIcon.propTypes = {
  status: number,
};

export default PaymentStatusIcon;
